import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useLanguage } from '../../i18n/LanguageContext';
import { api } from '../../services/api';

interface EditProfileModalProps {
  currentEmail: string;
  currentPhone: string;
  onClose: () => void;
  onSaved: (email: string, phone: string) => void;
}

export default function EditProfileModal({ currentEmail, currentPhone, onClose, onSaved }: EditProfileModalProps) {
  const { token } = useAuth();
  const { t } = useLanguage();
  const [email, setEmail] = useState(currentEmail);
  const [phone, setPhone] = useState(currentPhone);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token || !email.trim() || !phone.trim()) return;

    setLoading(true);
    setError('');
    try {
      await api.updateGarageContact({ email, phone }, token);
      onSaved(email, phone);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('settings.failedToSave'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-modal-overlay">
      <div className="settings-modal" onClick={e => e.stopPropagation()}>
        <div className="settings-modal-header">
          <h3>{t('settings.editProfile')}</h3>
          <button className="settings-modal-close" onClick={onClose}>✕</button>
        </div>
        {error && <div className="settings-toast settings-toast-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="settings-form-row">
            <input value={email} onChange={e => setEmail(e.target.value)} placeholder={t('settings.emailPlaceholder')} type="email" required />
          </div>
          <div className="settings-form-row">
            <input value={phone} onChange={e => setPhone(e.target.value)} placeholder={t('settings.phonePlaceholder')} required />
          </div>
          <button type="submit" className="settings-btn-primary" disabled={loading}>
            {loading ? t('common.saving') : t('common.saveChanges')}
          </button>
        </form>
      </div>
    </div>
  );
}
